var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',{staticClass:"tablet-list-item"},[_c('td',{staticClass:"no"},[_vm._v(_vm._s(_vm.no))]),_c('td',{staticClass:"macaddress"},[_vm._v(_vm._s(_vm.row.mac))]),_c('td',{staticClass:"status",class:_vm.statusTextClass},[_vm._v(_vm._s(_vm.row.status))])])
}
var staticRenderFns = []

export { render, staticRenderFns }